const INITIAL_STATE = 'INITIAL_STATE'
const SET_AUTHORIZATION = 'SET_AUTHORIZATION'
const SET_USERINFO = 'SET_USERINFO'
const SET_FILESERVER = 'SET_FILESERVER'
const SET_PICSERVER = 'SET_PICSERVER'

export { INITIAL_STATE, SET_AUTHORIZATION, SET_USERINFO, SET_FILESERVER,SET_PICSERVER }
